import { useState, useEffect } from "react";
import useTips from "../../hooks/useTips";
import TipsSidebar from "./TipsSidebar";
import TipContent from "./TipContent";

const TipsLayout = () => {
    const {
        tips,
        loading,
        error
    } = useTips();

    const [selectedTip, setSelectedTip] = useState(tips[0]);

    useEffect(() => {

        if (tips.length > 0) {
            setSelectedTip(tips[0]);
        }

    }, [tips]);




    if (loading) {

        return (
            <section className="py-20 text-center">
                Loading health tips...
            </section>
        );

    }



    if (error) {

        return (
            <section className="py-20 text-center">
                Failed to load health tips.
            </section>
        );

    }



    if (!tips.length) {

        return (
            <section className="py-20 text-center">
                No health tips available.
            </section>
        );

    }



    return (
        <section className="py-10 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] lg:grid-cols-[340px_1fr] gap-6 lg:gap-10 items-start">

                    <TipsSidebar
                        tips={tips}
                        selectedTip={selectedTip}
                        setSelectedTip={setSelectedTip}
                    />

                    <TipContent tip={selectedTip} />

                </div>

            </div>
        </section>
    );
};

export default TipsLayout;